<template>
  <section v-if="virtualCourses && virtualCourses.length > 0" id="virtual-training-summary"
    class="virtual-section bg-black">
    <div class="container-fluid px-md-5">
      <div class="row mb-5 align-items-end" data-aos="fade-up">
        <div class="col-lg-7">
          <h2 class="display-2 fw-900 text-white mb-0 letter-spacing-tight">Academia<br><span
              class="text-danger">en linea</span></h2>
        </div>
        <div class="col-lg-5 text-lg-end pb-2">
          <p class="text-secondary lead mb-4">Acceso inmediato a tácticas de élite desde cualquier lugar.</p>
          <RouterLink to="/virtual-training" class="btn-tactical-wide">
            Explorar cursos
          </RouterLink>
        </div>
      </div>

      <div class="row g-4">
        <div v-for="(course, index) in virtualCourses" :key="index" class="col-12 col-xl-6" data-aos="fade-up"
          :data-aos-delay="index * 150">
          <div class="cinematic-card">
            <div class="img-container">
              <div class="bg-img" :style="{ backgroundImage: `url(${course.image})` }"></div>
              <div class="card-overlay"></div>

              <div class="play-trigger">
                <i class="bi bi-play-fill"></i>
              </div>

              <div class="top-badge">
                <span class="badge-line"></span>
                Curso virtual
              </div>
            </div>

            <div class="card-meta d-flex justify-content-between align-items-start pt-3">
              <div class="meta-left">
                <h3 class="course-name">{{ course.name }}</h3>
                <div class="specs d-flex gap-3 text-secondary mt-1">
                  <span><i class="bi bi-hd"></i> VIDEO 4K</span>
                  <span><i class="bi bi-clock"></i> ACCESO DE POR VIDA</span>
                </div>
              </div>
              <div class="meta-right text-end">
                <span class="price-tag">${{ course.price }}</span>
                <div class="cta-link text-danger mt-1">COMPRA AHORA <i class="bi bi-arrow-right"></i></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref } from 'vue';
import providerImg from "@/assets/img/Tactical/tactical_03.jpg";
import dryFireImg from "@/assets/img/Tactical/tactical_06.jpg";
import awarenessImg from "@/assets/img/Tactical/tactical_10.jpg";
import fitnessImg from "@/assets/img/Tactical/tactical_11.jpg";

const virtualCourses = ref([
  { name: "Provider Course Virtual Training", price: "250.00", image: providerImg },
  { name: "Dry-Fire Virtual Training", price: "65.00", image: dryFireImg },
  { name: "Situational Awareness 2", price: "90.00", image: awarenessImg },
  { name: "Protector Fitness Online Training", price: "110.00", image: fitnessImg }
]);
</script>

<style scoped>
.virtual-section {
  padding: 120px 0;
  overflow: hidden;
  border-top: 4px solid #ff3131;
}

.fw-900 {
  font-weight: 900;
}

.letter-spacing-tight {
  letter-spacing: -3px;
}

/* Cinematic Card Styles */
.cinematic-card {
  cursor: pointer;
  position: relative;
}

.img-container {
  position: relative;
  height: 400px;
  /* Tamaño grande para impacto visual */
  overflow: hidden;
  border: 1px solid #222;
  transition: border-color 0.4s ease;
}

.bg-img {
  position: absolute;
  inset: 0;
  background-size: cover;
  background-position: center;
  filter: brightness(0.7) contrast(1.1);
  transition: transform 0.8s cubic-bezier(0.2, 0, 0.2, 1);
}

.card-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.6) 0%, transparent 100%);
  transition: opacity 0.4s ease;
}

/* Play Button centralizado */
.play-trigger {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0.8);
  width: 80px;
  height: 80px;
  background: rgba(255, 49, 49, 0.9);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 2.5rem;
  opacity: 0;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  z-index: 5;
}

/* Hover Effects */
.cinematic-card:hover .img-container {
  border-color: #ff3131;
}

.cinematic-card:hover .bg-img {
  transform: scale(1.05);
  filter: brightness(0.9);
}

.cinematic-card:hover .play-trigger {
  opacity: 1;
  transform: translate(-50%, -50%) scale(1);
}

/* Badges y Meta */
.top-badge {
  position: absolute;
  top: 20px;
  left: 20px;
  color: #fff;
  font-size: 0.7rem;
  font-weight: 800;
  display: flex;
  align-items: center;
  gap: 8px;
  z-index: 4;
}

.badge-line {
  width: 30px;
  height: 2px;
  background: #ff3131;
}

.course-name {
  font-weight: 900;
  font-size: 1.6rem;
  color: #fff;
  text-transform: uppercase;
  margin: 0;
}

.price-tag {
  font-weight: 900;
  font-size: 1.8rem;
  color: #fff;
  line-height: 1;
}

.specs {
  font-size: 0.75rem;
  font-weight: 700;
}

.cta-link {
  font-size: 1rem;
  font-weight: 900;
  letter-spacing: 1px;
}
.cta-link:hover {
  letter-spacing: 2px;
  transition: 0.3s;
  /* sombre */
  box-shadow: 0 0 10px rgba(255, 49, 49, 0.7);
  padding: 0 5px;
  border-radius: 4px;
}

/* Botón Header */
.btn-tactical-wide {
  display: inline-block;
  padding: 15px 40px;
  background: #ff3131;
  color: #fff;
  text-decoration: none;
  font-weight: 900;
  letter-spacing: 1px;
  transition: 0.3s;
}

.btn-tactical-wide:hover {
  background: #d62828;
  transform: translateY(-3px);
}

@media (max-width: 991px) {
  .img-container {
    height: 250px;
  }

  .display-2 {
    font-size: 3.5rem;
  }
}
</style>